import { Link, useParams } from "react-router-dom";
import "./attributeHistory.scss";
import { useTranslation } from "react-i18next";
import {
  convertToCommaSeparatedNumberwithoutDecimal,
  formatAmountWithCommas,
  getPaymentPrefix,
} from "@/utility/common";
import { dateFunc } from "@/components/Functions/dateFunc";

import PaymentStatusColorCode from "@/pages/CaseDetail/PaymentStatus/PaymentStatusColorCode";
export const useCreditorDistributionHeaders = ({
  creditorDetails,
  documnetId,
}: {
  creditorDetails: any;
  documnetId: any;
}) => {
  const { caseId, creditorId } = useParams();
  const amountCellRenderers = (params: any) => {
    const amount = params.data.amount;
    const decimalPlace = params.data.decimalPlace;
    const paymentUnitName = params.data.paymentUnitName;
    let formattedAmount = amount;
    if (decimalPlace !== null) {
      formattedAmount = formatAmountWithCommas(amount, decimalPlace);
    } else {
      formattedAmount = convertToCommaSeparatedNumberwithoutDecimal(amount);
    }
    if (paymentUnitName) {
      formattedAmount += ` ${paymentUnitName}`;
    }
    return formattedAmount;
  };

  const { t } = useTranslation();

  return [
    {
      field: "",
      type: "",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.cheque"
      ),
      width: 100,
      sortable: true,
      unSortIcon: true,
      cellRendererParams: {
        selectedDoumnetId: documnetId || "",
      },
      cellRenderer: "checqDownloadRenderer",
    },
    {
      type: "paymentReference",
      field: "paymentReference",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.paymentReference"
      ),
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return (
          <Link
            to={`/case/${caseId}/payment/${params?.data?.paymentId}?creditorName=${creditorDetails.creditorName}&creditorId=${creditorId}`}
          >
            <span className="motif-body2-default-regular text-bold-underline">
              {" "}
              {params?.data?.paymentReference}
            </span>
          </Link>
        );
      },
    },
    {
      field: "accountName",
      type: "accountName",
      sortable: true,
      unSortIcon: true,
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.accountName"
      ),
    },
    {
      field: "subAccountName",
      type: "subAccountName",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.subAccountName"
      ),
      sortable: true,
      unSortIcon: true,
    },

    {
      field: "distributionName",
      type: "distributionName",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.distributionName"
      ),
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return params.data.distributionName !== null
          ? params.data.distributionName
          : "-";
      },
    },
    {
      field: "amount",
      sortable: true,
      unSortIcon: true,
      type: "amount",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.amount"
      ),
      headerClass: "stepHeaderClass",
      cellClass: "align-right",
      cellRenderer: amountCellRenderers,
    },
    {
      field: "prefix",
      sortable: true,
      unSortIcon: true,
      type: "prefix",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.prefix"
      ),
      cellRenderer: function (params: any) {
        return getPaymentPrefix(params.data.prefix);
      },
    },
    {
      field: "paymentStatus",
      sortable: true,
      unSortIcon: true,
      type: "paymentStatus",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.status"
      ),
      cellRenderer: function (params: any) {
        return (
          <PaymentStatusColorCode paymentStatus={params.data.paymentStatus} />
        );
      },
    },
    {
      field: "payeeName",
      sortable: true,
      unSortIcon: true,
      type: "payeeName",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.payeeName"
      ),
    },
    {
      field: "issueDate",
      sortable: true,
      unSortIcon: true,
      type: "issueDate",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.issueDate"
      ),
      cellRenderer: function (params: any) {
        return params.data.issueDate
          ? dateFunc(params.data.issueDate).formattedDateOnly
          : "-";
      },
    },
    {
      field: "postedDate",
      sortable: true,
      unSortIcon: true,
      type: "postedDate",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.postedDate"
      ),
      cellRenderer: function (params: any) {
        return params.data.postedDate
          ? dateFunc(params.data.postedDate).formattedDateOnly
          : "-";
      },
    },
    {
      field: "voidedDate",
      type: "voidedDateType",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.voidedDate"
      ),
      width: 150,
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return dateFunc(params.data.voidedDate).formattedDateOnly;
      },
    },
    {
      field: "statusUpdateDate",
      sortable: true,
      unSortIcon: true,
      type: "statusUpdateDateType",
      headerName: t(
        "pages.creditors.creditorDistributionTab.tableColumns.statusUpdateDate"
      ),
      cellRenderer: function (params: any) {
        return params.data.statusUpdateDate
          ? dateFunc(params.data.statusUpdateDate).formattedDateOnly
          : "-";
      },
    },
  ];
};
export const useCreditorSettlementHeaders = ({
  creditorDetails,
}: {
  creditorDetails: any;
}) => {
  const { caseId, creditorId } = useParams();
  const amountCellRenderers = (params: any) => {
    const amount = params.data.totalSettlementAmount;
    const decimalPlace = params.data.decimalPlace;
    const paymentUnitName = params.data.unitName;
    let formattedAmount = amount;
    if (decimalPlace !== null) {
      formattedAmount = formatAmountWithCommas(amount, decimalPlace);
    } else {
      formattedAmount = convertToCommaSeparatedNumberwithoutDecimal(amount);
    }
    if (paymentUnitName) {
      formattedAmount += ` ${paymentUnitName}`;
    }
    return formattedAmount;
  };

  const { t } = useTranslation();

  return [
    {
      type: "paymentReference",
      field: "paymentReference",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.paymentReference"
      ),
      sortable: true,
      unSortIcon: true,
    },
    {
      field: "creditorReference",
      type: "creditorReference",
      sortable: true,
      unSortIcon: true,
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.creditorId"
      ),
    },
    {
      field: "creditorDisplayName",
      type: "creditorDisplayName",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.creditorName"
      ),
      sortable: true,
      unSortIcon: true,
      wrapText: true,
      autoHeight: true,
    },
    {
      field: "payeeName",
      type: "payeeNameType",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.payeeName"
      ),
      sortable: true,
      unSortIcon: true,
      wrapText: true,
      autoHeight: true,
    },

    {
      field: "assineeReference",
      type: "assineeReference",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.assigneeID"
      ),
      sortable: true,
      unSortIcon: true,
      cellRenderer: function (params: any) {
        return params?.data?.assigneeId !== creditorId &&
          params?.data?.assigneeId ? (
          <Link to={`/case/${caseId}/creditor/${params?.data?.assigneeId}`}>
            <span className="motif-body2-default-regular text-bold-underline">
              {" "}
              {params?.data?.assineeReference}
            </span>
          </Link>
        ) : (
          params?.data?.assineeReference
        );
      },
    },
    {
      field: "assigneeDisplayName",
      sortable: true,
      unSortIcon: true,
      type: "assigneeDisplayName",
      wrapText: true,
      autoHeight: true,
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.assigneeName"
      ),
      headerClass: "stepHeaderClass",
      cellClass: "align-right",
      cellRenderer: function (params: any) {
        return params?.data?.assigneeId !== creditorId ? (
          <Link to={`/case/${caseId}/creditor/${params?.data?.assigneeId}`}>
            <span className="motif-body2-default-regular text-bold-underline">
              {" "}
              {params?.data?.assigneeDisplayName}
            </span>
          </Link>
        ) : (
          params?.data?.assigneeDisplayName
        );
      },
    },
    {
      field: "totalSettlementAmount",
      sortable: true,
      unSortIcon: true,
      type: "totalSettlementAmount",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.settlementAmount"
      ),
      headerClass: "stepHeaderClass",
      cellClass: "align-right",
      cellRenderer: amountCellRenderers,
    },
    {
      field: "accountName",
      sortable: true,
      unSortIcon: true,
      type: "accountName",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.accountName"
      ),
    },
    {
      field: "subAccountName",
      sortable: true,
      unSortIcon: true,
      type: "subAccountName",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.subAccountName"
      ),
    },
    {
      field: "prefix",
      sortable: true,
      unSortIcon: true,
      type: "prefix",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.prefix"
      ),
      cellRenderer: function (params: any) {
        return getPaymentPrefix(params.data.prefix);
      },
    },
    {
      field: "status",
      sortable: true,
      unSortIcon: true,
      type: "status",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.status"
      ),
      cellRenderer: function (params: any) {
        return <PaymentStatusColorCode paymentStatus={params.data.status} />;
      },
    },
    {
      field: "issueDate",
      sortable: true,
      unSortIcon: true,
      type: "issueDate",
      headerName: t(
        "pages.creditors.creditorDistributionTab.settelmentTableColumns.issueDate"
      ),
      cellRenderer: function (params: any) {
        return params.data.issueDate
          ? dateFunc(params.data.issueDate).formattedDateOnly
          : "-";
      },
    },
  ];
};
